import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // Importez les styles du carrousel
import carouselImage1 from '../assets/img/carousel.jpg';
import carouselImage2 from '../assets/img/carousel1.jpg';
import carouselImage3 from '../assets/img/carousel2.jpg';
import carouselImage4 from '../assets/img/carousel3.jpg';
import carouselImage5 from '../assets/img/carousel4.jpeg';
import Img1 from '../assets/img/propos/2.jpg';
import img2 from '../assets/img/actualite/1.jpg';
import img3 from '../assets/img/actualite/2.jpg';
import img4 from '../assets/img/actualite/3.jpg';
import Logo1 from '../assets/img/Logo01.jpg';
import Logo2 from '../assets/img/Logo2.png';
import Logo3 from '../assets/img/Logo fond blanc.jpg';
import Logo4 from '../assets/img/Logo3.jpg';
import Logo5 from '../assets/img/Logo4.jpg';
import Logo6 from '../assets/img/Logo5.jpg';
import NavBar from './components/nav';
import Footer from './components/Footer';
import CustomCursor from './components/CustomCursor';
import ContactImg from '../assets/img/contact.jpg';
import rib from '../assets/img/RIB.jpg';
import BtnFlottant from "./components/BtnFlottant"; // Import du composant
import { Link } from "react-router-dom"; // Import de Link
import pdf from "../assets/img/Ba_Nsangu.pdf";

const Home = () => {
  const partners = [
    {
      url: "https://partner3.com",
      logo: Logo3,
      alt: "Partner Logo 3"
    },
    {
      url: "https://partner3.com",
      logo: Logo4,
      alt: "Partner Logo 3"
    },
    {
      url: "https://partner3.com",
      logo: Logo6,
      alt: "Partner Logo 3"
    },
    {
      url: "https://partner3.com",
      logo: Logo5,
      alt: "Partner Logo 3"
    },
    {
      url: "https://partner3.com",
      logo: Logo2,
      alt: "Partner Logo 3"
    },
    {
      url: "https://partner3.com",
      logo: Logo1,
      alt: "Partner Logo 3"
    },
  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  const carouselImages = [
    carouselImage1,
    carouselImage2,
    carouselImage3,
    carouselImage4,
    carouselImage5,
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev === carouselImages.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? carouselImages.length - 1 : prev - 1));
  };

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);

    return () => clearInterval(interval);
  }, [currentSlide]);

  // Revenir en haut de la page après le chargement
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll vers le haut de la page
  }, []); // Le tableau vide [] signifie que cela s'exécute une fois après le premier rendu

  return (
    <div className="overflow-x-hidden">
      <CustomCursor />
      <NavBar />

      {/* Header Carousel */}
      <motion.header
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="relative h-[600px]"
      >
        <div className="relative w-full h-full overflow-hidden">
          {carouselImages.map((image, index) => (
            <div
              key={index}
              className={`absolute inset-0 w-full h-full transition-opacity duration-700 ${
                index === currentSlide ? 'opacity-100' : 'opacity-0'
              }`}
            >
              <img
                src={image}
                alt={`Slide ${index + 1}`}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/30 flex justify-center items-center">
                <div className="text-center text-white max-w-4xl px-6">
                  <motion.h1
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: 0.3, duration: 0.8 }}
                    className="text-5xl md:text-6xl font-bold leading-tight"
                  >
                    BIENVENUE CHEZ <span className="text-orange-400 block mt-2">PERSPECTIVE CONGO</span>
                  </motion.h1>
                  <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.6, duration: 0.8 }}
                    className="mt-6 text-xl md:text-2xl font-light"
                  >
                    Nous voulons être la vitrine du Congo en Loire-Atlantique.
                  </motion.p>
                  <motion.div
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="mt-8 px-8 py-3 bg-orange-400 text-white text-lg rounded-full hover:bg-orange-500 transition-all duration-300 shadow-lg inline-block"
                  >
                    <Link to="/apropos">Nous découvrir</Link>
                  </motion.div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </motion.header>

      {/* Utilisation du composant FloatingButtons */}
      <BtnFlottant />

      {/* About Section */}
      <motion.section
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="py-20 bg-gradient-to-r from-orange-400 via-orange-500 to-pink-500"
      >
        <div className="container mx-auto px-6">
          <div className="flex flex-col md:flex-row items-center gap-12">
            <div className="md:w-1/2">
              <motion.img
                initial={{ scale: 0.9 }}
                whileInView={{ scale: 1 }}
                transition={{ duration: 0.8 }}
                src={Img1}
                className="w-full rounded-2xl shadow-2xl transform hover:scale-105 transition-transform duration-500"
                alt="About"
              />
            </div>
            <div className="md:w-1/2 text-white">
              <h2 className="text-4xl font-bold mb-6">À propos</h2>
              <p className="text-xl leading-relaxed mb-8">
                Perspective Congo depuis sa création en 2007 à Nantes, se veut être la vitrine du
                Congo en Loire Atlantique.
              </p>
              <motion.div
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="inline-block px-8 py-3 bg-white text-orange-500 rounded-full text-lg font-semibold hover:bg-orange-100 transition-colors shadow-lg"
              >
                <Link to="/apropos">Voir plus</Link>
              </motion.div>
            </div>
          </div>
        </div>
      </motion.section>

      {/* News Section */}
      <motion.section
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="py-20 bg-gradient-to-r from-blue-600 to-indigo-700"
      >
        <div className="container mx-auto px-6 text-white">
          <h2 className="text-4xl font-bold text-center mb-4">Actualité</h2>
          <p className="text-xl text-center mb-12 text-blue-200">
            Restez informés de nos dernières activités ou de celles à venir
          </p>
          <div className="grid md:grid-cols-3 gap-8">
            {/* News cards */}
            <motion.div
              whileHover={{ y: -10 }}
              className="bg-white/10 rounded-2xl overflow-hidden backdrop-blur-sm shadow-xl"
            >
              <img src={img3} className="w-full h-48 object-cover hover:scale-105 transition-transform duration-500" alt="News 1" />
              <div className="p-6">
                <p className="text-lg">Perspective campus: Réchauffement climatique. Que pourrait devenir l'Afrique ?</p>
                <p className="text-lg">04 Décembre 2024.</p>
              </div>
            </motion.div>

            <motion.div
              whileHover={{ y: -10 }}
              className="bg-white/10 rounded-2xl overflow-hidden backdrop-blur-sm shadow-xl"
            >
              <img src={img2} className="w-full h-48 object-cover hover:scale-105 transition-transform duration-500" alt="News 2" />
              <div className="p-6">
                <p className="text-lg">Partenariat avec NSP pour la construction du M'bongui moderne du village Mouyondzi.</p>
                <p className="text-lg">En cours</p>
              </div>
            </motion.div>

            <motion.div
              whileHover={{ y: -10 }}
              className="bg-white/10 rounded-2xl overflow-hidden backdrop-blur-sm shadow-xl"
            >
              <img src={img4} className="w-full h-48 object-cover hover:scale-105 transition-transform duration-500" alt="News 3" />
              <div className="p-6">
                {/* <p className="text-lg">Perspective campus: La gestion intégrée des eaux pluviales : prévenir les risques d'inondation.</p> */}
              </div>
            </motion.div>
          </div>

          {/* Bouton pour afficher un fichier PDF */}
          <div className="flex justify-center mt-12">
            <motion.a
              href={pdf} // Remplacez par le chemin de votre fichier PDF
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="px-8 py-3 bg-orange-400 text-white text-lg rounded-full hover:bg-orange-500 transition-all duration-300 shadow-lg"
            >
            Bulletin Trimestriel Ba Nsangu.pdf
            </motion.a>
          </div>

          {/* Support Section */}
          <div className="mt-20">
            <h2 className="text-4xl font-bold mb-6">Nous soutenir</h2>
            <p className="text-xl mb-8">
              Faites un don par chèque à Perspective Congo. Notre adresse au 1 Rue Louis Préaubert chez MDA, 44000 Nantes.
              Ou par virement bancaire.
            </p>
            <div className="flex justify-center">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => window.open(rib, "_blank")} // Ouvre l'image dans un nouvel onglet
                className="px-8 py-3 bg-orange-400 text-white text-lg rounded-full hover:bg-orange-500 transition-all duration-300 shadow-lg"
              >
                Voir le RIB
              </motion.button>
            </div>
          </div>
        </div>
      </motion.section>

      {/* Partners Section */}
      <motion.section
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="py-20 bg-gradient-to-r from-orange-400 to-pink-500"
      >
        <div className="container mx-auto px-6 text-white">
          <h2 className="text-4xl font-bold text-center mb-4">Nos partenaires de confiance</h2>
          <p className="text-xl text-center mb-12 max-w-3xl mx-auto">
            Nos partenaires nous permettent de penser "Ici, là-bas" c'est grâce à eux que nous
            "Pensons aussi au Congo".
          </p>

          {/* Carrousel pour mobile */}
          <div className="md:hidden">
            <Carousel
              showArrows={false} // Désactive les flèches de navigation
              showStatus={false} // Désactive l'affichage du statut (par exemple, "1/6")
              showThumbs={false} // Désactive les miniatures
              infiniteLoop={true} // Permet un défilement infini
              autoPlay={true} // Défilement automatique
              interval={3000} // Intervalle de défilement (3 secondes)
              centerMode={true} // Centre le slide actuel
              centerSlidePercentage={50} // Affiche deux logos à la fois
              emulateTouch={true} // Permet le défilement tactile
            >
              {partners.map((partner, index) => (
                <motion.div
                  key={index}
                  whileHover={{ scale: 1.1 }}
                  className="bg-white/20 p-4 rounded-xl backdrop-blur-sm shadow-lg mx-2"
                >
                  <a href={partner.url} target="_blank" rel="noopener noreferrer">
                    <img
                      src={partner.logo}
                      alt={partner.alt}
                      className="w-full h-24 object-contain filter brightness-100 hover:brightness-110"
                    />
                  </a>
                </motion.div>
              ))}
            </Carousel>
          </div>

          {/* Grille pour desktop */}
          <div className="hidden md:grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
            {partners.map((partner, index) => (
              <motion.div
                key={index}
                whileHover={{ scale: 1.1 }}
                className="bg-white/20 p-4 rounded-xl backdrop-blur-sm shadow-lg"
              >
                <a href={partner.url} target="_blank" rel="noopener noreferrer">
                  <img
                    src={partner.logo}
                    alt={partner.alt}
                    className="w-full h-24 object-contain filter brightness-100 hover:brightness-110"
                  />
                </a>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.section>

      {/* Contact Section */}
      <motion.section
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="py-20 bg-gradient-to-r from-blue-600 to-blue-800"
      >
        <div className="container mx-auto px-6">
          <div className="flex flex-col md:flex-row gap-12 items-center">
            <div className="md:w-1/2">
              <img
                src={ContactImg}
                className="rounded-2xl shadow-2xl w-full object-cover transform hover:scale-105 transition-transform duration-500"
                alt="Contact"
              />
            </div>
            <div className="md:w-1/2">
              <h2 className="text-4xl font-bold mb-8 text-white">Nous joindre</h2>
              <form className="bg-white/10 backdrop-blur-md p-8 rounded-2xl shadow-xl space-y-4">
                <input
                  type="text"
                  placeholder="Votre nom"
                  className="w-full px-6 py-3 bg-white/20 text-white placeholder-white/70 rounded-xl border border-white/20 focus:outline-none focus:ring-2 focus:ring-white/50 transition-all duration-300"
                />
                <input
                  type="email"
                  placeholder="Votre email"
                  className="w-full px-6 py-3 bg-white/20 text-white placeholder-white/70 rounded-xl border border-white/20 focus:outline-none focus:ring-2 focus:ring-white/50 transition-all duration-300"
                />
                <input
                  type="text"
                  placeholder="Objet du message"
                  className="w-full px-6 py-3 bg-white/20 text-white placeholder-white/70 rounded-xl border border-white/20 focus:outline-none focus:ring-2 focus:ring-white/50 transition-all duration-300"
                />
                <textarea
                  placeholder="Votre message"
                  rows="5"
                  className="w-full px-6 py-3 bg-white/20 text-white placeholder-white/70 rounded-xl border border-white/20 focus:outline-none focus:ring-2 focus:ring-white/50 resize-none transition-all duration-300"
                ></textarea>
                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  type="submit"
                  className="w-full px-6 py-3 bg-white text-blue-600 rounded-xl font-semibold hover:bg-blue-50 transition-all duration-300 shadow-lg"
                >
                  Envoyez
                </motion.button>
              </form>
            </div>
          </div>
        </div>
      </motion.section>

      <Footer />
    </div>
  );
};

export default Home;